export default __webpack_public_path__ + "static/media/stream-icon-bottom-nav-mobile-active.bc2a0619.webp";